import ModificarCliente from "./Clientes/ModificarCliente";
import NuevoCliente from "@/store/modules/Clientes/NuevoCliente";
import { get } from "lodash-es";
import axios from "axios";

export default {
  modules: {
    NuevoCliente,
    ModificarCliente,
  },
  state: {
    clientes: [],
    quickFilter: "",
  },
  mutations: {
    setClientes(state, payload) {
      state.clientes = payload;
    },
    setQuickFilter(state, payload) {
      state.quickFilter = payload;
    },
  },
  actions: {
    async getClientes(context) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetClientesVigentes",
        parameters: [],
      });
      if (resp.data.ok) {
        const clientes = get(resp, "data.result[0]");
        context.commit("setClientes", clientes);
      }
      return resp.data; //
    },
    setQuickFilter(context, payload) {
      context.commit("setQuickFilter", payload);
    },
  },
  getters: {
    getClientes(state) {
      return state.clientes;
    },
    getQuickFilter(state) {
      return state.quickFilter;
    },
  },
};
